import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  generateDocsGraphData,
} from "../../../../common/graphHelper";
import { ChartCall } from "../../../charts/chartCall";
const _props = {
  dataListTemplate: "",
  period: "",
  graphConfig: {},
  setReset:()=>{}
};

export function DocsUploadedAnalytics(props = _props) {
  const [isMounted, setIsMounted] = useState(true);
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [],
    data:[],
    totalDatasets: 0,
  });
  let refreshChart = useSelector( x => x.chart.isDataEditted)
  

  useEffect(() => {
    async function fetchDataAndSetGraphData() {
      const data = await generateDocsGraphData(
        dispatch,
        props.dataListTemplate,
        props.period,
        props.graphConfig,
        isMounted
      );
      setGraphData({
        labels: data.labels,
        datasets: data.datasets,
        data:data.data,
        totalDatasets: data.total,
      });
    }
    fetchDataAndSetGraphData();
    
  }, [props.period, props.graphConfig, refreshChart]);

  useState(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);

  return (
    <div>
      <ChartCall
        chartType={props.graphConfig.chartType}
        setReset={props.setReset}
        config={{
          datasets: graphData.datasets,
          labels: graphData.labels,
          totalDatasets: graphData.totalDatasets,
          data:graphData.data,
          graphConfig: props.graphConfig,
          dataListTemplate:props.dataListTemplate,
          period:props.period
        }}
      />
    </div>
  );
}
